export const PROJECTS = {
  // LIVE_DATA: 'game-live-data',
  // BIG_WINS: 'big-wins-feed',
  PERSONAL: 'personal',
};
const PREFIX = 'casino';
export const CHANNEL_NAMESPACES = {
  // LIVE_DATA: `${PREFIX}-${PROJECTS.LIVE_DATA}`,
  // BIG_WINS: `${PREFIX}-${PROJECTS.BIG_WINS}`,
  PERSONAL: `${PREFIX}-${PROJECTS.PERSONAL}`,
};

export const CENTRIFUGO_INITIAL_DATA_URL = '/centrifugo/subscription-data';

export const CENTRIFUGO_INITIAL_DATA_QUERY_PARAM = {
  PROJECT: 'project',
  PRODUCT_TYPE: 'product-type',
};

export enum CENTRIFUGO_STATUS {
  INIT = 'init',
  LOADING = 'loading',
  ERROR = 'error',
  SUCCESS = 'success',
}
